let uuid = 0;
export default function () {
  return String(uuid++);
}
